import { Component } from '@angular/core';
import { ReporteOperacionRepository } from '../../../servicio/reporte-operacion.repository';
import { reporteClienteNaveRequest } from '../../../domain/reportes-operacion.request';
import { FormControl, FormGroup } from '@angular/forms';
import { newmetadate } from 'src/app/shared/components/datatable/domain/datatable-domain';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { UtilService, dropdownItems, optionExcelExport } from 'src/app/services/util.service';
import { listarNaveViajeeResponseDTO, reporteClienteNaveResponseDTO } from '../../../domain/reportes-operacion.response';

@Component({
    selector: 'app-b-reporte-cliente-nave',
    imports: [
        SharedModule
    ],
    standalone: true,
    templateUrl: './b-reporte-cliente-nave.component.html',
    styleUrl: './b-reporte-cliente-nave.component.css'
})
export class BReporteClienteNaveComponent {

  constructor(
    private readonly reporte: ReporteOperacionRepository,
    private readonly util: UtilService
  ) { }

  ngOnInit(): void {
    this.ngOnInitForm()
  }

  Naves: dropdownItems[] = []
  ngOnInitForm() {

    this.reporte.ListarNaveViaje().subscribe(response => {
      if (response.datos.status === 200) {
        this.Naves = response.datos.result.map(r => {
          return { label: r.nvia_codigo + " - " + r.nave_nombre + " - " + r.nvia_nroviaje, value: r.nvia_codigo }
        })
      }
    })

    this.group = new FormGroup({
      desde: new FormControl(null, null),
      hasta: new FormControl(null, null),
      nave: new FormControl(null, null)
    })
  }

  metadatatable: newmetadate[] =
    [
      { title: "Nave", field: "nave_nombre", inputType: "text", style: { 'justify': 'left' } },
      { title: "Viaje", field: "nvia_nroviaje", inputType: "text" },
      { title: "Razon Social", field: "entc_razonsocial", inputType: "text", style: { 'justify': 'left' } },
      { title: "Ruc", field: "entc_dociden", inputType: "text" }
    ]

  group: FormGroup
  datatable: reporteClienteNaveResponseDTO[] = []
  search() {
    const request = <reporteClienteNaveRequest>{}
    request.desde = this.group.value.desde
    request.hasta = this.group.value.hasta
    request.nave = this.group.value.nave
    this.datatable = []
    this.reporte.reporteClienteNave(request).subscribe(response => {
      if (response.datos.status === 200) {
        this.datatable = response.datos.result
      }
    })
  }

  export() {
    var data = this.datatable.map(r => ({ 'NAVE': r.nvia_nroviaje, 'RAZON SOCIAL': r.entc_razonsocial, 'RUC': r.entc_dociden }));

    const option: optionExcelExport = {
      fileName: "Reporte Cliente Nave",
      sheets: [
        {
          data: data,
          sheetName: "Datos",
          sizeColumns: [
            { index: 1, size: 15 },
            { index: 2, size: 105 },
            { index: 3, size: 15 }
          ]
        }],
      typeFile: '.xlsx'
    }
    this.util.ExportExcel(option)
  }
}
